import { render, staticRenderFns } from "./DeleteBranchAlert.vue?vue&type=template&id=71b6e4fb&scoped=true"
import script from "./DeleteBranchAlert.vue?vue&type=script&lang=js"
export * from "./DeleteBranchAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6e4fb",
  null
  
)

export default component.exports